import React from 'react';
import Logo from './site/Logo';
import { Link } from 'react-router-dom';
import { ArrowRight, Instagram, Mail, MapPin, Phone, Star, Youtube } from 'lucide-react';
import { BRAND, NAV, waLink } from './site/brand';
import './site/footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="vk-footer">
      <div className="vk-footer__band">
        <div className="vk-wrap vk-footer__band-inner">
          <p className="vk-display vk-footer__band-title">Planning a trip? <span>Talk to a real person.</span></p>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="vk-btn vk-btn--hot">Chat on WhatsApp <ArrowRight size={18} /></a>
        </div>
      </div>

      <div className="vk-wrap vk-footer__grid">
        <div className="vk-footer__brand">
          <Link to="/" className="vk-footer__logo" aria-label="VK Tours home"><Logo width="170" height="52" /></Link>
          <p>Handcrafted holidays across India and 30+ countries — flights, hotels, visas and on-trip support from one team, for 15 years.</p>
          <p className="vk-footer__offices">{BRAND.offices}</p>
          <div className="vk-footer__social">
            <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" aria-label="VK Tours on Instagram"><Instagram size={18} /></a>
            <a href={BRAND.youtube} target="_blank" rel="noopener noreferrer" aria-label="VK Tours on YouTube"><Youtube size={18} /></a>
            <a href={BRAND.googleReviews} target="_blank" rel="noopener noreferrer" aria-label="VK Tours Google reviews"><Star size={18} /></a>
          </div>
        </div>

        <div>
          <h4>International</h4>
          <ul>{NAV.international.slice(0, 8).map((d) => <li key={d.path}><Link to={d.path}>{d.name}</Link></li>)}</ul>
        </div>

        <div>
          <h4>India</h4>
          <ul>{NAV.india.slice(0, 8).map((d) => <li key={d.path}><Link to={d.path}>{d.name}</Link></li>)}</ul>
        </div>

        <div>
          <h4>Plan</h4>
          <ul>
            {NAV.themes.map((d) => <li key={d.path}><Link to={d.path}>{d.name}</Link></li>)}
            {NAV.services.slice(0, 2).map((d) => <li key={d.path}><Link to={d.path}>{d.name}</Link></li>)}
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <ul className="vk-footer__contact">
            <li><a href={BRAND.phoneLink} data-testid="footer-mobile-phone"><Phone size={16} /> {BRAND.phone}</a></li>
            <li><a href={BRAND.landlineLink} data-testid="footer-landline-phone"><Phone size={16} /> {BRAND.landline}</a></li>
            <li><a href={`mailto:${BRAND.email}`}><Mail size={16} /> {BRAND.email}</a></li>
            <li><span><MapPin size={16} /> {BRAND.address}</span></li>
          </ul>
        </div>
      </div>

      <div className="vk-footer__bottom">
        <div className="vk-wrap vk-footer__bottom-inner">
          <p>© {year} VK Tours. All rights reserved.</p>
          <nav aria-label="Legal">
            <Link to="/privacy-policy" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/terms-conditions" data-testid="footer-terms-link">Terms</Link>
            <Link to="/cancellation-policy" data-testid="footer-cancellation-link">Cancellation</Link>
            <Link to="/refund-policy" data-testid="footer-refund-link">Refunds</Link>
            <Link to="/shipping-policy" data-testid="footer-shipping-link">Service delivery</Link>
            <Link to="/contact-us" data-testid="footer-contact-link">Contact</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
